import { Tooltip } from '@ewf/components/Tooltip';
import { WORKER_STATUS } from '@shared/types/entities/worker';
import questionMarkIcon from '@ewf/assets/icons/question.svg';

export const AutoInstallationScheduledChip = (): JSX.Element => {
  return (
    <div className="item-center flex w-fit rounded-full bg-blue/20 px-3 py-1 text-center text-sm text-blue">
      {WORKER_STATUS.AutoInstallationScheduled}
      <Tooltip
        side="bottom"
        content={
          <div className="max-w-[300px] p-2">
            Solutions will be automatically installed and run when this subscription is already
            allowed for results submission.
          </div>
        }
      >
        <div className="ml-2 flex h-[16px] w-[16px] justify-center rounded-full bg-gray-100">
          <img src={questionMarkIcon} width={11} height={11} alt="more info" />
        </div>
      </Tooltip>
    </div>
  );
};
